import { useState, type FormEvent } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { api } from '../api';
import { IconMoon, IconSun } from '../ui/icons';

export function Login({ theme, onTheme }: { theme: 'light' | 'dark'; onTheme: () => void }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const qc = useQueryClient();
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true); setErr('');
    try {
      await api.auth.login(email.trim(), password);
      await qc.invalidateQueries();
      const next = sp.get('next');
      nav(next && next.startsWith('/') && !next.startsWith('//') ? next : '/');
    } catch (x) {
      setErr(x instanceof Error ? x.message : 'Could not sign in.');
    } finally { setBusy(false); }
  };
  return (
    <div className="loginwrap">
      <form className="loginc" onSubmit={submit}>
        <div className="clogo"><i />Delta Partners</div>
        <div><h1 style={{ margin: '6px 0 4px', fontSize: 24, letterSpacing: '-.5px' }}>Sign in</h1><div className="sm mut">Workspace for the Delta Partners team.</div></div>
        <label className="fld">Work email<input className="inp" type="email" autoComplete="username" value={email} onChange={e => setEmail(e.target.value)} required autoFocus /></label>
        <label className="fld">Password<input className="inp" type="password" autoComplete="current-password" value={password} onChange={e => setPassword(e.target.value)} required /></label>
        {err && <div className="err" role="alert">{err}</div>}
        <button className="bt pri" style={{ height: 44 }} disabled={busy}>{busy ? <span className="spin" /> : null}Sign in</button>
        <div className="xs mut">Accounts are created by an admin. Forgot your password? Ask an admin for a reset link.</div>
      </form>
      <div style={{ position: 'absolute', top: 16, right: 16 }}>
        <button className="ib" onClick={onTheme} aria-label="Switch light or dark">{theme === 'dark' ? <IconSun /> : <IconMoon />}</button>
      </div>
    </div>
  );
}
